import React from "react";
import { GoPlus } from "react-icons/go";

export const PaymentMethods = ({ create }) => {
  return (
    <>
      <div className="row mb-3">
        <div className="col-md-12 col-sm-12">
          <div className="paymentsMethodsBlock">
            <div
              className="cardPayment newDeliveryOption"
              role="button"
              tabIndex={0}
              onClick={create}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  create(e);
                }
              }}
            >
              <GoPlus />
              Nuevo
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
